// extracted by mini-css-extract-plugin
module.exports = {"HeaderWell":"GameOverNotRegistered_HeaderWell__3CE0v"};